(function ($) {
    "use strict";
    $(function () {

        var treatments = [];

        $('.price-list li').each(function (index, el) {
            var node = $(el).contents();
            treatments.push({
                title: node[0].textContent,
                price: node[1].textContent
            });
        });

        /**
         * Init search widget 
         */
        $('#live-search').on('keyup', renderSearch);

        function renderSearch() {
            var keyword = $('#live-search').val().toLowerCase();
            var resultWrapper = $('#search-results');
            resultWrapper.html('');

            if (keyword.length < 2) {
                return;
            }

            var results = treatments.filter(function (el) {
                return el.title.toLowerCase().indexOf(keyword) > -1
            });

            var search = new RegExp(keyword, "g");

            for (var i = 0; i < results.length; i++) {
                var text = results[i].title.toLowerCase();
                text = text.replace(search, '<mark>$&</mark>');
                resultWrapper.append('<li>' + text + '<span>' + results[i].price + '</span></li>');
            }
        }

        $('#interactive').on('change', function () {
            if (document.location.href.indexOf('int=1') == -1) {
                document.location.href += '&int=1'
            } else {
                document.location.href = document.location.href.replace(/&int=1/, '')
            }
        });
    });
})(jQuery);